// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VwadE1alJsDrw5u6rcb1 {
  width: 50%;
}

p {
  text-align: justify;
}

.kz1BSEq8IcdTtsVHJwcL {
  display: flex;
  justify-content: center;
}

.yqAxWDeUkT8r6l8zxT9H {
  display: flex;
  justify-content: flex-end;
}

.ybni8utkkOgp3RIpqXII {
  margin: 0;
}

.ZVIXKfKSkAgQXGAN_7kA {
  margin-top: var(--spacing-xxSmall);
}

@media screen and (max-width: 768px) {
  .VwadE1alJsDrw5u6rcb1 {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App/views/AccountApproval/AccountApproval.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".grid {\n  width: 50%;\n}\n\np {\n  text-align: justify;\n}\n\n.container {\n  display: flex;\n  justify-content: center;\n}\n\n.buttonRow {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.row {\n  margin: 0;\n}\n\n.button-success {\n  margin-top: var(--spacing-xxSmall);\n}\n\n@media screen and (max-width: 768px) {\n  .grid {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `VwadE1alJsDrw5u6rcb1`,
	"container": `kz1BSEq8IcdTtsVHJwcL`,
	"buttonRow": `yqAxWDeUkT8r6l8zxT9H`,
	"row": `ybni8utkkOgp3RIpqXII`,
	"button-success": `ZVIXKfKSkAgQXGAN_7kA`
};
export default ___CSS_LOADER_EXPORT___;
